import { FlyoutButton } from "@omni/ui/components/FlyoutButton/flyoutButton.component";
import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import * as HeaderModule from "@/redux/modules/value/header/header.module";
import * as HeaderSelectors from "@/redux/modules/value/header/header.selectors";
import { useIsClientSide } from "@/utils/hooks/isClient.hook";

export type FlyoutButtonContainerProps = {
    title: string;
    size: "small" | "large";
};

const FlyoutButtonContainer = ({ title, size }: FlyoutButtonContainerProps) => {
    const dispatch = useThunkDispatch();
    const flyoutActive = useSelector(HeaderSelectors.isFlyoutActive);
    const isClient = useIsClientSide();

    const handleUpdate = () => {
        dispatch(HeaderModule.update({ flyoutActive: !flyoutActive }));
    };

    return (
        <FlyoutButton
            title={title}
            size={size}
            active={isClient && !!flyoutActive}
            update={handleUpdate}
        />
    );
};

export { FlyoutButtonContainer };
